export const tokensDark = {
  grey: { 0: "#ffffff", 10: "#f6f6f6", 50: "#f0f0f0", 100: "#e0e0e0", 200: "#c2c2c2", 300: "#a3a3a3", 400: "#858585", 500: "#666666", 600: "#525252", 700: "#3d3d3d", 800: "#292929", 900: "#141414", 1000: "#000000" },
  primary: { 100: "#f3e5f5", 200: "#ce93d8", 300: "#ba68c8", 400: "#ab47bc", 500: "#9c27b0", 600: "#8e24aa", 700: "#7b1fa2", 800: "#6a1b9a", 900: "#4a148c" },
  secondary: { 50: "#fce4ec", 100: "#f8bbd0", 200: "#f48fb1", 300: "#f06292", 400: "#ec407a", 500: "#e91e63", 600: "#d81b60", 700: "#c2185b", 800: "#ad1457", 900: "#880e4f" },
};

export const tokensLight = {
  grey: { 0: "#000000", 10: "#141414", 50: "#292929", 100: "#3d3d3d", 200: "#525252", 300: "#666666", 400: "#858585", 500: "#a3a3a3", 600: "#c2c2c2", 700: "#e0e0e0", 800: "#f0f0f0", 900: "#f6f6f6", 1000: "#ffffff" },
  primary: { 100: "#4a148c", 200: "#6a1b9a", 300: "#7b1fa2", 400: "#8e24aa", 500: "#9c27b0", 600: "#ab47bc", 700: "#ba68c8", 800: "#ce93d8", 900: "#f3e5f5" },
  secondary: { 50: "#880e4f", 100: "#ad1457", 200: "#c2185b", 300: "#d81b60", 400: "#e91e63", 500: "#ec407a", 600: "#f06292", 700: "#f48fb1", 800: "#f8bbd0", 900: "#fce4ec" },
};

export const themeSettings = (mode) => {
  const colors = mode === "dark" ? tokensDark : tokensLight;
  return {
    palette: {
      mode,
      ...(mode === "dark"
        ? {
            primary: { main: colors.primary[400], light: colors.primary[200] },
            secondary: { main: colors.secondary[300] },
            neutral: { dark: colors.grey[700], main: colors.grey[500], light: colors.grey[100] },
            background: { default: "#1a1a2e", paper: "#16213e" },
          }
        : {
            primary: { main: colors.primary[500], light: colors.primary[700] },
            secondary: { main: colors.secondary[500] },
            neutral: { dark: colors.grey[700], main: colors.grey[500], light: colors.grey[100] },
            background: { default: "#fafafa", paper: "#ffffff" },
          }),
    },
    typography: {
      fontFamily: ["Inter", "sans-serif"].join(","),
      fontSize: 12,
      h1: { fontFamily: ["Inter", "sans-serif"].join(","), fontSize: 40 },
      h2: { fontFamily: ["Inter", "sans-serif"].join(","), fontSize: 32 },
      h3: { fontFamily: ["Inter", "sans-serif"].join(","), fontSize: 24 },
      h4: { fontFamily: ["Inter", "sans-serif"].join(","), fontSize: 20 },
      h5: { fontFamily: ["Inter", "sans-serif"].join(","), fontSize: 16 },
      h6: { fontFamily: ["Inter", "sans-serif"].join(","), fontSize: 14 },
    },
  };
};
